

export const formatNumberWithComma = (numb) => {
    let str = numb.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
}

// Format date for display
// export const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
// };

export const formatCreatedAtDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        month: 'short',    // "Mar"
        day: '2-digit',   // "02"
        year: 'numeric'    // "2025"
    });
};

export const formatDateToYYYMMDD = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0]; // YYYY-MM-DD
};

export const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    
    if (seconds < 60) return `${seconds} seconds ago`;
    if (seconds < 3600) return `${Math.floor(seconds/60)} minutes ago`;
    if (seconds < 86400) return `${Math.floor(seconds/3600)} hours ago`;
    return `${Math.floor(seconds/86400)} days ago`;
};



export const getUserDetails = (request) => {
    try {
        const userString = sessionStorage.getItem("userInfo");

        if (!userString) {
            throw new Error("No user details found in session storage");
        }

        const user = JSON.parse(userString);

        if (!user) {
            throw new Error("User details are empty");
        }

        const role = user.role || "";
        const name = user.name || "";
        const id = user.id || "";

        switch (request) {
            case "role":
                return role;
            case "roleId":
                return id;
            case "name":
                return name;
            default:
                throw new Error("Invalid request parameter");
        }
    } catch (error) {
        console.error("Error in getUserDetails:", error.message);
        return null;
    }
};


export const generateTodaysDate =()=>{
    const today = new Date().toISOString().split('T')[0];
    return today;
}

export const staffCategories =[
    { id: 1, name: 'Coach' },
    { id: 2, name: 'Cashier' },
    { id: 3, name: 'Cleaner' }
]


export const getStaffCategory = (id) => {
    if (!id) return "Invalid ID";
    let Id = parseInt(id);
    const item = staffCategories.find(item => item.id === Id);
    return item?.name || "Not Found";
};

export const getClientNameByNumber = (id, Data) => {
    // let Id = parseInt(id);
    let nameFound = "Name Not found";
    const record = Data.find((item) => item.ClientNumber === id);
    if (record) {
        nameFound = record.FName +" " + record.FName;
    } else {
        return "No Record Found";
    }

    return nameFound;
};

export const getStaffNameById = (id, Data) => {
    let Id = parseInt(id);
    let nameFound = "Name Not found";
    const record = Data.find((item) => item.id === Id);
    if (record) {
        nameFound = record.FName + record.FName;
    } else {
        return "No Record Found";
    }

    return nameFound;
};
export const getClientByNumber = (id, Data,Type) => {
    let Id = parseInt(id);
    let nameFound = "Name Not found";
    const record = Data.find((item) => item.ClientNumber === Id);
    if (record) {
        switch(Type){
            case 'name':
                nameFound = record.FName + record.FName;
                break;
            case 'conatc':
                nameFound = record.Contact;
                break;
            case 'sex':
                nameFound = record.Sex;
                break;
            default:
                return nameFound = "Default Name";
        }
    } else {
        return "No Record Found";
    }

    return nameFound;
};
